import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { ReferenceType } from '../../model/ReferenceType';
import { Roles } from '../../model/Roles';

@Component({
  selector: 'app-dispatch-profile-page',
  templateUrl: './dispatch-profile-page.component.html',
  styleUrls: ['./dispatch-profile-page.component.scss']
})
export class DispatchProfilePageComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.dispatchProfile();
  }


  dispatchProfile() {

    if(!this.authService.getToken()){
         this.router.navigate(['/no-profile']);
    }
    const userProfile = this.authService.getLoggedUserInfo().getLoggedUserProfileByPriority();
    if (userProfile == null) {
      this.router.navigate(['/no-profile']);
      return;
    }

    let targetRoute = '';
    switch (userProfile.referenceType) {

      case ReferenceType.Employee:

        if (this.authService.hasRole(Roles.PortalUser)) {
          targetRoute = '/claimsCenter';
        }
        else if (this.authService.hasRole(Roles.MobileAppUser)) {
          targetRoute = '/mobileCenter';
        } 
        else if (this.authService.hasRole(Roles.CalculatorUser)) {
          targetRoute = '/calculationCenter';
        } 
        else {
          targetRoute = '/no-profile';
        }

        break;

      case ReferenceType.Workshop:
        targetRoute = '/workshopCenter';
        break;

       case ReferenceType.Dealer:
        targetRoute = '/dealerCenter';
        break;

      case ReferenceType.PartsSupplier:
        targetRoute = '/partsSupplierCenter';
        break;

      // case  ReferenceType.CarTechnician: 
      //   targetRoute = '/carTechnicianCenter';
      //    break; 

      case ReferenceType.InsuranceCompany:
        targetRoute = '/insuranceCompanyCenter';
        break;

      case ReferenceType.CalculatorClientCompany:
        targetRoute = '/calculationCenter';
        break;

      default:
        targetRoute = '';
        break;
    }
    this.router.navigate([targetRoute]);
  }

}
